/* eslint-disable import/prefer-default-export */
import { CSSProperties } from '@material-ui/core/styles/withStyles';

import { theme } from 'src/styles/theme';

type SizeType = {
  medium: NonNullable<CSSProperties['height']>;
  small: NonNullable<CSSProperties['height']>;
};

export const SIZE: SizeType = {
  medium: theme.customHeights.regularButton,
  small: theme.customHeights.smallButton,
};
